import { Action } from 'redux';

import { SetSensitiveLabel } from '../../../bootstrap/redux/actions/AppActionTypes';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';

export interface SetSensitiveLabelAction extends Action {
    item: IContentInfo;
}

export function setSensitiveLabelAction(item: SetSensitiveLabelAction['item']): SetSensitiveLabelAction {
    return {
        type: SetSensitiveLabel,
        item
    };
}
